<template>
  <div class="filters">
    <div v-if="!booleanArePlaysEmpty" class="filters-container">
      <!-- general filters -->
      <div class="filters__general" :class="arrayFiltersGeneralClass">
        <!-- tournaments -->
        <div class="drop-down-container tournaments">
          <BDropdown
            :value="objectTournamentSelected"
            aria-role="list"
            :max-height="dropDownHeight"
            :class="dropDownPosition"
            :mobile-modal="false"
            scrollable
            expanded
            @input="onTournamentSelected"
          >
            <template #trigger>
              <div class="drop-down-trigger">
                <div class="selected-tournament">
                  <img :src="getTournamentLogoUrl(objectTournamentSelected.id)" alt="" />
                  <div>
                    {{ objectTournamentSelected.name }}
                  </div>
                </div>
                <div class="icn-arrow-down">
                  <img src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_arrow_down.svg" alt="" />
                </div>
              </div>
            </template>
            <BDropdownItem
              v-for="objectTournament of arrayAvailableTournaments"
              :value="objectTournament"
              :key="objectTournament.id"
              aria-role="listitem"
            >
              <div class="item-tournament">
                <!--              <div class="item-tournament__logo">
                  <img :src="getTournamentLogoUrl(objectTournament.id)" :alt="objectTournament.name" />
                </div>-->
                <div class="item-tournament__name">
                  {{ objectTournament.name }}
                </div>
              </div>
            </BDropdownItem>
          </BDropdown>
        </div>
        <!-- seasons -->
        <div class="drop-down-container seasons">
          <BDropdown
            :value="objectSeasonSelected"
            aria-role="list"
            :max-height="dropDownHeight"
            :class="dropDownPosition"
            :mobile-modal="false"
            scrollable
            expanded
            @input="onSeasonSelected"
          >
            <template #trigger>
              <div class="drop-down-trigger">
                <div class="selected-generic">
                  {{ objectSeasonSelected.name }}
                </div>
                <div class="icn-arrow-down">
                  <img src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_arrow_down.svg" alt="" />
                </div>
              </div>
            </template>
            <BDropdownItem
              v-for="objectSeason of objectTournamentSelected.arraySeasons"
              :value="objectSeason"
              :key="objectSeason.id"
              aria-role="listitem"
            >
              <div class="item-generic">
                {{ objectSeason.name }}
              </div>
            </BDropdownItem>
          </BDropdown>
        </div>
        <!-- match days -->
        <div class="drop-down-container match-days">
          <BDropdown
            :value="objectMatchDaySelected"
            aria-role="list"
            :max-height="dropDownHeight"
            :class="dropDownPosition"
            :mobile-modal="false"
            scrollable
            expanded
            @input="onMatchDaySelected"
          >
            <template #trigger>
              <div class="drop-down-trigger">
                <div class="selected-generic">
                  {{ objectMatchDaySelected.stringMatchDayAbbreviation }}
                </div>
                <div class="icn-arrow-down">
                  <img src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_arrow_down.svg" alt="" />
                </div>
              </div>
            </template>
            <BDropdownItem
              v-for="objectMatchDay of objectSeasonSelected.arrayMatchDays"
              :value="objectMatchDay"
              :key="objectMatchDay.stringMatchDayAbbreviation"
              aria-role="listitem"
            >
              <div class="item-generic">
                {{ objectMatchDay.stringMatchDayName }}
              </div>
            </BDropdownItem>
          </BDropdown>
        </div>
        <!-- match teams -->
        <div class="drop-down-container teams">
          <BDropdown
            :value="objectTeamSelected"
            aria-role="list"
            :max-height="dropDownHeight"
            :class="dropDownPosition"
            :mobile-modal="false"
            scrollable
            expanded
            @input="onTeamSelected"
          >
            <template #trigger>
              <div class="drop-down-trigger">
                <div class="selected-generic">
                  {{ objectTeamSelected.colloquial_name }}
                </div>
                <div class="icn-arrow-down">
                  <img src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_arrow_down.svg" alt="" />
                </div>
              </div>
            </template>
            <BDropdownItem
              v-for="objectTeam of objectSeasonSelected.arrayTeams"
              :value="objectTeam"
              :key="objectTeam.team_id"
              aria-role="listitem"
            >
              <div class="item-generic">
                {{ objectTeam.colloquial_name }}
              </div>
            </BDropdownItem>
          </BDropdown>
        </div>
        <!-- games -->
        <div class="drop-down-container games">
          <BDropdown
            :value="objectGameSelected"
            aria-role="list"
            :max-height="dropDownHeight"
            :class="dropDownPosition"
            :mobile-modal="false"
            scrollable
            expanded
            @input="onGameSelected"
          >
            <template #trigger>
              <div class="drop-down-trigger">
                <div v-if="objectGameSelected.homeTeam" class="selected-generic item-game">
                  <div class="match-day">
                    {{ objectGameSelected.roundAbbreviation }}
                  </div>
                  <div class="team-logo">
                    <img :src="objectGameSelected.homeTeam.logo" alt="" />
                  </div>
                  <div class="text">
                    {{ objectGameSelected.homeTeam.colloquial_name }}
                  </div>
                  <div class="text score">{{ objectGameSelected.score[0] }} - {{ objectGameSelected.score[1] }}</div>
                  <div class="text">
                    {{ objectGameSelected.awayTeam.colloquial_name }}
                  </div>
                  <div class="team-logo">
                    <img :src="objectGameSelected.awayTeam.logo" alt="" />
                  </div>
                </div>
                <div class="icn-arrow-down">
                  <img src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_arrow_down.svg" alt="" />
                </div>
              </div>
            </template>
            <BDropdownItem
              v-for="objectGame of arrayAvailableGames"
              :value="objectGame"
              :key="objectGame.game_id"
              aria-role="listitem"
            >
              <div class="item-generic item-game">
                <div>
                  {{ objectGame.roundAbbreviation }}
                </div>
                <div class="team-logo">
                  <img :src="objectGame.homeTeam.logo" alt="" />
                </div>
                <div class="text">
                  {{ objectGame.homeTeam.colloquial_name }}
                </div>
                <div class="text score">{{ objectGame.score[0] }} - {{ objectGame.score[1] }}</div>
                <div class="text">
                  {{ objectGame.awayTeam.colloquial_name }}
                </div>
                <div class="team-logo">
                  <img :src="objectGame.awayTeam.logo" alt="" />
                </div>
              </div>
            </BDropdownItem>
          </BDropdown>
        </div>
        <!-- players -->
        <div v-if="objectTeamSelected.arrayPlayers" class="drop-down-container players">
          <BDropdown
            :value="objectPlayerSelected"
            aria-role="list"
            :max-height="dropDownHeight"
            :class="dropDownPosition"
            :mobile-modal="false"
            scrollable
            expanded
            @input="onPlayerSelected"
          >
            <template #trigger>
              <div class="drop-down-trigger">
                <div class="selected-generic">
                  {{ objectPlayerSelected.player_name }}
                </div>
                <div class="icn-arrow-down">
                  <img src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_arrow_down.svg" alt="" />
                </div>
              </div>
            </template>
            <BDropdownItem
              v-for="objectPlayer of objectTeamSelected.arrayPlayers"
              :value="objectPlayer"
              :key="objectPlayer.id"
              aria-role="listitem"
            >
              <div class="item-generic">
                {{ objectPlayer.player_name }}
              </div>
            </BDropdownItem>
          </BDropdown>
        </div>
        <!-- categories -->
        <div class="drop-down-container categories">
          <BDropdown
            :value="objectCategorySelected"
            aria-role="list"
            :max-height="dropDownHeight"
            :class="dropDownPosition"
            :mobile-modal="false"
            scrollable
            expanded
            @input="onCategorySelected"
          >
            <template #trigger>
              <div v-if="objectCategorySelected" class="drop-down-trigger">
                <div class="selected-generic">
                  {{ objectCategorySelected.name }}
                </div>
                <div class="icn-arrow-down">
                  <img src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_arrow_down.svg" alt="" />
                </div>
              </div>
            </template>
            <BDropdownItem
              v-for="objectMainCategory of advancedFilterCategoriesAvailable"
              :value="objectMainCategory"
              :key="objectMainCategory.name"
              aria-role="listitem"
            >
              <div class="item-generic">
                {{ objectMainCategory.name }}
              </div>
            </BDropdownItem>
          </BDropdown>
        </div>
      </div>
      <div v-show="booleanIsDifferentSeason" class="filters__season-add">
        NOTA: Los datos en toda la página serán pertenecientes al torneo {{ objectTournamentSelected.name }}
        {{ objectSeasonSelected.name }}
      </div>
      <!-- show advanced -->
      <div role="button" class="filters__show-advanced" @click="onClickShowAdvanced">
        {{ stringShowAdvancedText }}
      </div>
      <div v-if="booleanAreAdvancedVisible" class="filters__advanced">
        <MediaPlayerAdvancedFilters
          :action-id="actionId"
          :available-subcategories="arrayAvailableSubcategories"
          :main-category="objectCategorySelected"
          :field-sectors="arrayFieldSectors"
          :conditions="objectConditions"
          :is-best-plays="objectCategorySelected.booleanIsBestPlays || objectCategorySelected.booleanIsMinutesPlayed"
        />
      </div>
      <div role="button" class="filters__button-apply" @click="onClickApplyFilters">
        <span v-if="actionId === 5">Ver partido</span>
        <span v-else>OK</span>
      </div>
    </div>
    <div class="filters__empty" v-if="booleanArePlaysEmpty">
      <div class="filters__empty__warning">
        <img src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_alert.svg" alt="" />
      </div>
      <div class="filters__empty__message">
        No existen resultados para esta búsqueda
      </div>
      <div class="filters__empty__buttons">
        <div role="button" class="filters__empty__buttons__button cancel" @click="onClickCancel">
          Cancelar
        </div>
        <div role="button" class="filters__empty__buttons__button modify" @click="booleanArePlaysEmpty = false">
          Modificar filtros
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  fieldSectorsFromSectionsIndex,
  rivalFieldSectionsFromSectionsIndex,
} from '@/data/meda-player/advanced-filter-soccer-field';
import { findFieldArea } from '@/data/generators/statisticsFieldsData';
import { getPlayContentFields } from '@/data/media-player-play-indexes';
import { BDropdown, BDropdownItem } from 'buefy/dist/esm/dropdown';
import { regularLeague, cup, cupLegacy, cupLegacyAbb } from '@/utils/play-off-abbreviations';
import { mapActions, mapGetters, mapState } from 'vuex';
import axios from 'axios';

const playContentIndex = getPlayContentFields();
let playsPerGame = null;
const subcategoriesExceptions = [];
const rivalTransformCategories = ['g-23', 'g-24', 'g-25'];
const categoriesTypes = {
  player: 1,
  team: 2,
  goalkeeper: 3,
};

const objectBestPlaysCategoryIds = {
  games: [607, 608, 12, 55, 54, 35, 14, 52, 15, 53, 466, 477],
  team: [607, 608, 12, 55, 54, 35, 14, 52, 15, 53, 466, 477, 40, 257, 39],
  player: {
    regular: [
      12,
      35,
      10,
      27,
      607,
      61,
      519,
      98,
      101,
      109,
      112,
      121,
      122,
      127,
      128,
      135,
      136,
      141,
      142,
      161,
      170,
      179,
      702,
      730,
      466,
      217,
      211,
      232,
      235,
      239,
      242,
      282,
      284,
      289,
      291,
      296,
      485,
      486,
      487,
      488,
      14,
      15,
      257,
    ],
    goalkeeper: [55, 324, 323, 608, 39, 774, 802, 52, 53, 40, 54],
  },
};

export default {
  name: 'MediaPlayerSearchFilters',
  components: {
    BDropdown,
    BDropdownItem,
    MediaPlayerAdvancedFilters: () => import('@/components/Sections/MediaPlayer-v3/MediaPlayerAdvancedFilters'),
  },
  props: {
    gamesByMatchDay: {
      type: Object,
      default: () => ({}),
    },
    teams: {
      type: Array,
      default: () => [],
    },
    actionId: {
      type: Number,
      default: 2,
    },
    controlsTitle: {
      type: String,
      default: '',
    },
    backCounter: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      booleanArePlaysEmpty: false,
      objectTournamentSelected: {
        arraySeasons: [],
      },
      objectSeasonSelected: {
        arrayMatchDays: [],
      },
      objectMatchDaySelected: {
        arrayGames: [],
      },
      objectGameSelected: {
        score: [0, 0],
        homeTeam: {},
        awayTeam: {},
      },
      objectPlayerSelected: {},
      objectTeamSelected: {
        arrayPlayers: [],
      },
      arraySelectedSubcategoryIds: [],
      arrayCategoriesIds: [],
      arrayRivalCategoriesIds: [],
      arrayCategoriesIdsRaw: [],
      objectCategorySelected: {},
      arrayAvailableTournaments: [],
      mapGamesByTeam: new Map(),
      booleanAreAdvancedVisible: false,
      numberTournamentIdSelected: 0,
      // gamesUrl: 'https://kkd48smit2.execute-api.us-west-2.amazonaws.com/qa/calendar/gamesBySeason?',
      gamesUrl: 'https://qyyibs1w0d.execute-api.us-west-2.amazonaws.com/prod/calendar/gamesBySeason?',
      // gamesUrl: 'https://sezc8crru5.execute-api.us-east-2.amazonaws.com/qa/calendar/gamesBySeason?',
      advancedFilterCategories: {
        games: [],
        player: [],
        team: [],
        goalkeeper: [],
        isEmpty: true,
      },
      stringQueryCategoryIds: '',
      stringQueryParams: '',
      advancedFilterCategoriesRaw: [],
      objectAdvancedFilterToApply: null,
      arrayFieldSectors: [
        { num: 13, status: true },
        { num: 14, status: true },
        { num: 15, status: true },
        { num: 16, status: true },
        { num: 9, status: true },
        { num: 10, status: true },
        { num: 11, status: true },
        { num: 12, status: true },
        { num: 5, status: true },
        { num: 6, status: true },
        { num: 7, status: true },
        { num: 8, status: true },
        { num: 1, status: true },
        { num: 2, status: true },
        { num: 3, status: true },
        { num: 4, status: true },
      ],
      objectConditions: {
        arrayLocality: [
          {
            text: 'Local',
            value: 1,
            isSelected: true,
          },
          {
            text: 'Visitante',
            value: 2,
            isSelected: true,
          },
        ],
        arrayTimeSections: [
          {
            text: '1-15',
            value: 1,
            isSelected: true,
          },
          {
            text: '16-30',
            value: 2,
            isSelected: true,
          },
          {
            text: '31-45',
            value: 3,
            isSelected: true,
          },
          {
            text: '46-60',
            value: 4,
            isSelected: true,
          },
          {
            text: '61-75',
            value: 5,
            isSelected: true,
          },
          {
            text: '75-90',
            value: 6,
            isSelected: true,
          },
        ],
      },
      maxGameId: 0,
    };
  },
  computed: {
    ...mapState('loginGeneral', ['mapTournaments']),
    ...mapGetters('loginGeneral', [
      'getModal',
      'getTournaments',
      'getSeasons',
      'getTournamentSelected',
      'getSeasonSelected',
    ]),
    booleanIsDifferentSeason() {
      return !['player', 'team'].includes(this.$route.name) && this.objectSeasonSelected.id !== this.getSeasonSelected;
    },
    arrayAvailableGames() {
      let arrayAvailableGames = null;
      if ([3, 4].includes(this.actionId)) {
        arrayAvailableGames =
          this.objectTeamSelected.team_id && this.objectSeasonSelected.mapGamesByTeam
            ? this.objectSeasonSelected.mapGamesByTeam.get(this.objectTeamSelected.team_id) || []
            : [];
      } else {
        arrayAvailableGames = this.objectMatchDaySelected.arrayGames;
      }
      arrayAvailableGames.sort((a, b) => b.numberDateTimeMillis - a.numberDateTimeMillis);
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.objectGameSelected = arrayAvailableGames.length ? arrayAvailableGames[0] : {};
      return arrayAvailableGames;
    },
    stringQueryCategories() {
      let queryCategories = '';
      const rivalCategories = [];
      // const categoriesAux = this.modalSectionSelected === 1 ? this.advancedFilter.categoryIds : this.currentCategories
      this.currentCategories.forEach((categoryId, index) => {
        let categoryIdAux = typeof categoryId === 'string' ? categoryId : categoryId.toString();
        let isRivalCategory = false;
        if (categoryIdAux.includes('_')) {
          isRivalCategory = true;
          categoryIdAux = Number(categoryIdAux.split('_')[0]);
          rivalCategories.push(categoryIdAux);
        }
        // eslint-disable-next-line no-param-reassign
        queryCategories += `${index > 0 ? '&' : ''}${isRivalCategory ? 'r' : ''}categories=${categoryIdAux}`;
      });
      this.setRivalCategories(rivalCategories);
      return queryCategories;
    },
    arrayAvailableSubcategories() {
      return this.objectCategorySelected.subcategoryGroups || [];
    },
    isPlayerGoalkeeper() {
      return this.actionId === 4 && this.objectPlayerSelected.position_id === 1;
    },
    advancedFilterCategoriesAvailable() {
      if (this.actionId === 4) {
        if (this.objectPlayerSelected.position_id === 1) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.objectCategorySelected = this.advancedFilterCategories.goalkeeper[0];
          return this.advancedFilterCategories.goalkeeper;
        } else {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.objectCategorySelected = this.advancedFilterCategories.player[0];
          return this.advancedFilterCategories.player;
        }
      }
      if (this.actionId === 2) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.objectCategorySelected = this.advancedFilterCategories.games[0];
        return this.advancedFilterCategories.games;
      }

      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.objectCategorySelected = this.advancedFilterCategories.team[0];
      return this.advancedFilterCategories.team;
    },
    arrayFiltersGeneralClass() {
      const arrayFiltersGeneralClass = [];
      switch (this.actionId) {
        case 2:
          arrayFiltersGeneralClass.push('summary-game-layout');
          break;
        case 3:
          arrayFiltersGeneralClass.push('summary-teams-layout');
          break;
        case 4:
          arrayFiltersGeneralClass.push('summary-players-layout');
          break;
        default:
          arrayFiltersGeneralClass.push('goals-layout');
      }
      return arrayFiltersGeneralClass;
    },
    stringShowAdvancedText() {
      return this.booleanAreAdvancedVisible ? 'Ocultar avanzado' : 'Mostrar avanzado';
    },
    dropDownHeight() {
      return this.windowWidth < 1023 ? 416 : 304;
    },
    dropDownPosition() {
      return this.isModalMode ? 'top-right' : 'bottom-right';
    },
    arrayMatchDays() {
      return Object.entries(this.gamesByMatchDay).map(([key, value]) => ({ key, name: value.name }));
    },
  },
  watch: {
    backCounter() {
      this.booleanArePlaysEmpty = false;
      this.resetSubcategories();
      this.resetFieldSectors();
      this.resetConditions();
      this.booleanAreAdvancedVisible = false;
      this.objectCategorySelected = this.advancedFilterCategoriesAvailable[0];
    },
    mapTournaments: {
      immediate: true,
      handler(newValue) {
        if (newValue.size) {
          this.arrayAvailableTournaments = Array.from(this.mapTournaments.values());
          this.objectTournamentSelected = this.arrayAvailableTournaments.find(
            objectTournament => objectTournament.id === this.getTournamentSelected,
          );
          this.objectSeasonSelected = this.objectTournamentSelected.arraySeasons.find(objectSeason => {
            return objectSeason.id === this.getSeasonSelected;
          });
        }
      },
    },
    objectSeasonSelected: {
      immediate: true,
      handler(newValue) {
        this.objectTournamentSelected.numberSeasonSelectedIndex = this.objectTournamentSelected.arraySeasons.findIndex(
          objectS => objectS.id === newValue.id,
        );
        if (!newValue.arrayMatchDays) {
          this.fillMatchDaysAndGames(newValue);
          this.fillSeasonPlayers(newValue);
        } else {
          this.objectMatchDaySelected = newValue.arrayMatchDays[0] || {};
          this.objectTeamSelected = newValue.arrayTeams[0] || {};
        }
      },
    },
    objectMatchDaySelected: {
      immediate: true,
      handler(newValue) {
        if (newValue.arrayGames && newValue.arrayGames.length) {
          this.objectGameSelected = newValue.arrayGames[0];
        }
      },
    },
    objectTeamSelected: {
      immediate: true,
      handler(newValue) {
        setTimeout(() => {
          if (this.objectSeasonSelected.mapPlayersByTeam) {
            if (!this.objectTeamSelected.arrayPlayers || !this.objectTeamSelected.arrayPlayers.length) {
              this.objectTeamSelected.arrayPlayers = this.objectSeasonSelected.mapPlayersByTeam.get(newValue.team_id);
            }
            this.objectPlayerSelected = this.objectTeamSelected.arrayPlayers[0];
          }
        }, 700);
      },
    },
    advancedFilterCategoriesAvailable: {
      immediate: true,
      handler(newValue) {
        if (newValue.length) {
          this.objectCategorySelected = newValue[0];
        }
      },
    },
    'objectCategorySelected.booleanIsBestPlays': {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.resetFieldSectors();
        }
      },
    },
  },
  methods: {
    ...mapActions('mediaGeneral', ['getPlayersBySeasons']),
    resetSubcategories() {
      if (this.objectCategorySelected.subcategoryGroups) {
        this.objectCategorySelected.subcategoryGroups.forEach(arraySubcategoryGroup => {
          arraySubcategoryGroup.forEach(objectSubcategory => {
            objectSubcategory.isSelected = true;
          });
        });
      }
    },
    resetFieldSectors() {
      this.arrayFieldSectors.forEach(objectFieldSector => {
        objectFieldSector.status = true;
      });
    },
    resetConditions() {
      this.objectConditions.arrayLocality.forEach(objectLocality => {
        objectLocality.isSelected = true;
      });
      this.objectConditions.arrayTimeSections.forEach(objectTimeSection => {
        objectTimeSection.isSelected = true;
      });
    },
    async applyGoalsFilters() {
      try {
        this.$emit('set-is-loading', true);
        this.objectAdvancedFilterToApply = null;
        this.arrayCategoriesIds = [12, 55];
        this.arrayRivalCategoriesIds = [54, 35];
        this.arrayCategoriesIdsRaw = ['12', '55', '54_r', '35_r'];
        const stringQueryCategoriesIds = 'categories=12&categories=55&rcategories=54&rcategories=35';
        const arrayPlays = await this.fetchPlays(stringQueryCategoriesIds, '');
        this.objectAdvancedFilterToApply = {
          gameId: this.objectGameSelected.game_id,
        };
        this.filterPlays(arrayPlays);
      } catch (e) {
        throw new Error(e);
      }
    },

    async applySummaryFilters() {
      try {
        this.$emit('set-is-loading', true);
        this.objectAdvancedFilterToApply = null;
        this.objectAdvancedFilterToApply = {
          arrayPlayingAs: this.objectConditions.arrayLocality.reduce((accumulator, objectLocality) => {
            if (objectLocality.isSelected) {
              accumulator.push(objectLocality.value);
            }
            return accumulator;
          }, []),
          arrayTimeSections: this.objectConditions.arrayTimeSections.reduce((accumulator, objectTimeSection) => {
            if (objectTimeSection.isSelected) {
              accumulator.push(objectTimeSection.value);
            }
            return accumulator;
          }, []),
          arrayFieldSections: this.arrayFieldSectors,
        };
        this.objectAdvancedFilterToApply.gameId = this.objectGameSelected.game_id;
        this.objectAdvancedFilterToApply.requiresRivalTransform = this.objectCategorySelected.requiresRivalTransform;
        this.arraySelectedSubcategoryIds = this.objectCategorySelected.booleanIsMinutesPlayed
          ? this.objectCategorySelected.arrayCategoriesIds
          : this.getSubcategories();
        this.arrayCategoriesIds = [];
        this.arrayRivalCategoriesIds = [];
        this.arrayCategoriesIdsRaw = [];
        const stringQueryCategoriesIds = this.arraySelectedSubcategoryIds.reduce(
          (accumulator, numberStringCategoryId, index) => {
            this.arrayCategoriesIdsRaw.push(numberStringCategoryId);
            let numberCategoryId = numberStringCategoryId;
            const booleanIsRivalCategory =
              typeof numberStringCategoryId === 'string' && numberStringCategoryId.includes('_');
            if (booleanIsRivalCategory) {
              numberCategoryId = Number(numberStringCategoryId.split('_')[0]);
              this.arrayRivalCategoriesIds.push(numberCategoryId);
            } else {
              this.arrayCategoriesIds.push(numberCategoryId);
            }
            return `${accumulator}${index > 0 ? '&' : ''}${
              booleanIsRivalCategory ? 'r' : ''
            }categories=${numberCategoryId}`;
          },
          '',
        );
        const stringQueryParams =
          this.actionId === 3
            ? `&team=${this.objectTeamSelected.team_id}`
            : this.actionId === 4
            ? `&player=${this.objectPlayerSelected.player_id}`
            : '';
        const arrayPlays = await this.fetchPlays(stringQueryCategoriesIds, stringQueryParams);
        this.filterPlays(arrayPlays);
      } catch (e) {
        throw new Error(e);
      }
    },
    async fetchPlays(stringQueryCategoriesId, stringQueryParams) {
      try {
        this.stringQueryCategoryIds = stringQueryCategoriesId;
        this.stringQueryParams = stringQueryParams;
        // let queryParams = '';
        // const areInitialPlayers =
        //   this.modalInitialState && this.modalInitialState.playerIds && this.modalInitialState.playerIds.length;
        // if (this.selectedType === 2) {
        //   if (this.modalInitialState.isFeaturedPlayers) {
        //     this.modalInitialState.playerIds.forEach(playerId => {
        //       queryParams += `&player=${playerId}`;
        //     });
        //     // only add players ids at first iteration when modal is opened
        //     this.modalInitialState.isFeaturedPlayers = false;
        //   } else if (this.getPlayerId) {
        //     queryParams += `&player=${this.getPlayerId}`;
        //   } else if (areInitialPlayers) {
        //     this.modalInitialState.playerIds.forEach(playerId => {
        //       queryParams += `&player=${playerId}`;
        //     });
        //   }
        // } else if (this.getTeamId && this.selectedType === 3) {
        //   queryParams += `&team=${this.getTeamId}`;
        // }
        // if (this.modalInitialState.isPost) {
        //   queryParams += '&isPost=1';
        // }
        const response = await axios.get(
          // https://gpela9u46i.execute-api.us-west-2.amazonaws.com/prod/videos/plays/seasons/
          `https://cpj4073446.execute-api.us-east-2.amazonaws.com/prod/videos/plays/seasons/${this.objectSeasonSelected.id}?${stringQueryCategoriesId}${stringQueryParams}`,
        );
        if (response.data && response.data.plays) {
          const plays = [...response.data.plays];
          if (response.data.plays_rival) {
            return plays.concat(response.data.plays_rival);
          }
          return plays;
        }
        return [];
      } catch (e) {
        throw new Error(e);
      }
    },
    async fetchCategories() {
      try {
        const response = await axios.get(
          'https://2gfppi9wb6.execute-api.us-east-2.amazonaws.com/prod/videos/categories',
        );
        return response.data || [];
      } catch (e) {
        return Promise.reject(e);
      }
    },

    filterPlays(arrayPlays) {
      const arrayFormattedPlays = this.getFormattedPlays(arrayPlays);
      const arrayFilteredPlays = arrayFormattedPlays.reduce((accumulator, objectPlay) => {
        if (this.objectAdvancedFilterToApply) {
          let booleanIsValidPlay = true;

          if (this.objectAdvancedFilterToApply.requiresRivalTransform) {
            booleanIsValidPlay = objectPlay.rivalTeamId === this.objectTeamSelected.team_id;
          }

          if (booleanIsValidPlay && this.objectAdvancedFilterToApply.arrayPlayingAs) {
            if ([3, 4].includes(this.actionId)) {
              booleanIsValidPlay = !(this.objectAdvancedFilterToApply.requiresRivalTransform &&
              this.objectAdvancedFilterToApply.arrayPlayingAs.length === 1
                ? objectPlay.teamId !== this.objectTeamSelected.team_id
                  ? this.objectAdvancedFilterToApply.arrayPlayingAs.includes(objectPlay.playingAs)
                  : !this.objectAdvancedFilterToApply.arrayPlayingAs.includes(objectPlay.playingAs)
                : !this.objectAdvancedFilterToApply.arrayPlayingAs.includes(objectPlay.playingAs));

              // objectPlay.teamId === this.objectTeamSelected.team_id &&
              // this.objectAdvancedFilterToApply.arrayPlayingAs.includes(objectPlay.playingAs);
            } else {
              booleanIsValidPlay = this.objectAdvancedFilterToApply.arrayPlayingAs.includes(objectPlay.playingAs);
            }
          }

          if (booleanIsValidPlay && this.objectAdvancedFilterToApply.arrayTimeSections) {
            booleanIsValidPlay = this.objectAdvancedFilterToApply.arrayTimeSections.includes(objectPlay.section);
          }

          if (
            booleanIsValidPlay &&
            this.objectAdvancedFilterToApply.coordinatePoint &&
            this.objectAdvancedFilterToApply.arrayFieldSections
          ) {
            const playFieldArea =
              findFieldArea(
                objectPlay[`x${this.objectAdvancedFilterToApply.coordinatePoint}`],
                objectPlay[`y${this.objectAdvancedFilterToApply.coordinatePoint}`],
              ) + 1;
            const fieldAreaString = `${playFieldArea}`;
            const playFieldSectorAux = fieldSectorsFromSectionsIndex[fieldAreaString];
            const playFieldSector = this.objectAdvancedFilterToApply.requiresRivalTransform
              ? this.arraySelectedSubcategoryIds.includes(`${objectPlay.categoryId}_r`)
                ? fieldSectorsFromSectionsIndex[`${rivalFieldSectionsFromSectionsIndex[fieldAreaString]}`]
                : playFieldSectorAux
              : playFieldSectorAux;
            booleanIsValidPlay = !!this.objectAdvancedFilterToApply.arrayFieldSections.find(
              objectFieldSection => objectFieldSection.num === playFieldSector && objectFieldSection.status,
            );
          }

          if (booleanIsValidPlay) {
            accumulator.push(objectPlay);
          }
        } else {
          accumulator.push(objectPlay);
        }
        return accumulator;
      }, []);
      this.$emit('set-is-loading', false);
      this.booleanArePlaysEmpty = !arrayFilteredPlays.length;
      if (!this.booleanArePlaysEmpty) {
        let numberPlaylistIndex = -1;
        if (this.objectAdvancedFilterToApply.gameId) {
          numberPlaylistIndex = arrayFilteredPlays.findIndex(objectPlay => {
            return this.objectAdvancedFilterToApply.gameId === objectPlay.gameId;
          });
        }
        this.booleanArePlaysEmpty = numberPlaylistIndex === -1;
        if (!this.booleanArePlaysEmpty) {
          this.$emit('click-apply-filters', {
            arrayFormattedPlays: arrayFilteredPlays,
            arrayCategoriesIds: [...this.arrayCategoriesIds],
            arrayRivalCategoriesIds: [...this.arrayRivalCategoriesIds],
            arrayCategoriesIdsRaw: [...this.arrayCategoriesIdsRaw],
            objectTournamentSelected: { ...this.objectTournamentSelected },
            objectGameSelected: { ...this.objectGameSelected },
            objectSeasonSelected: this.booleanIsDifferentSeason ? { ...this.objectSeasonSelected } : null,
            stringQueryCategoryIds: this.stringQueryCategoryIds,
            stringQueryParams: this.stringQueryParams,
            objectFilters: {
              numberActionId: this.actionId,
              numberMediaPlayerType: this.actionId === 3 ? 3 : this.actionId === 4 ? 2 : 1,
              objectCategorySelected: { ...this.objectCategorySelected },
              objectAdvancedFilters: {
                booleanIsPlayerGoalKeeper: this.isPlayerGoalkeeper,
                arraySelectedSubcategoryIds: this.arraySelectedSubcategoryIds
                  ? [...this.arraySelectedSubcategoryIds]
                  : null,
                booleanRequiresRivalTransform: this.objectAdvancedFilterToApply.requiresRivalTransform,
                numberCoordinatePoint: this.objectAdvancedFilterToApply.coordinatePoint,
                numberTeamId: this.actionId === 3 ? this.objectTeamSelected.team_id : null,
                numberPlayerId: this.actionId === 4 ? this.objectPlayerSelected.player_id : null,
                arrayPlayingAs: this.objectAdvancedFilterToApply.arrayPlayingAs
                  ? [...this.objectAdvancedFilterToApply.arrayPlayingAs]
                  : null,
                arrayTimeSections: this.objectAdvancedFilterToApply.arrayTimeSections
                  ? [...this.objectAdvancedFilterToApply.arrayTimeSections]
                  : null,
                arrayFieldSections: this.objectAdvancedFilterToApply.arrayFieldSections
                  ? [...this.objectAdvancedFilterToApply.arrayFieldSections]
                  : null,
              },
            },
            numberPlaylistIndex,
          });
        }
      }
    },

    getSubcategories(objectCategorySelected) {
      const objectCategorySelectedAux = objectCategorySelected || this.objectCategorySelected;
      if (!objectCategorySelectedAux) {
        this.isActive = true;
        return;
      }
      if (objectCategorySelectedAux.booleanIsBestPlays) {
        return objectCategorySelectedAux.arrayCategoriesIds;
      }
      const selectedIds = { total: [], toRemove: [] };
      if (objectCategorySelectedAux.subcategoryGroups && objectCategorySelectedAux.subcategoryGroups.length) {
        const groupLevel1Subcategories = objectCategorySelectedAux.subcategoryGroups[0];
        groupLevel1Subcategories.forEach(subcategory => {
          this.setSelectedSubcategoriesIds(subcategory, null, selectedIds);
        });
      } else {
        if (objectCategorySelectedAux.ids) {
          selectedIds.total.push(...objectCategorySelectedAux.ids);
        }
        if (objectCategorySelectedAux.rival_ids) {
          objectCategorySelectedAux.rival_ids.forEach(categoryId => {
            selectedIds.total.push(`${categoryId}_r`);
          });
        }
      }
      selectedIds.total = selectedIds.total.reduce((accumulator, selectedId) => {
        if (!selectedIds.toRemove.includes(selectedId)) {
          accumulator.push(selectedId);
        }
        return accumulator;
      }, []);
      if (!objectCategorySelected) {
        const lowerCaseName = objectCategorySelectedAux.name.toLowerCase();
        const isRivalSubject = lowerCaseName.includes('recibid');
        this.objectAdvancedFilterToApply.isRivalSubject = isRivalSubject;
        this.objectAdvancedFilterToApply.avoidCategorySingleName = isRivalSubject;
        this.objectAdvancedFilterToApply.coordinatePoint = objectCategorySelectedAux.coordinatePoint;
        this.objectAdvancedFilterToApply.requiresRivalTransform = objectCategorySelectedAux.requiresRivalTransform;
        // this.modalInitialState.avoidCategorySingleName = true;
      }
      return selectedIds.total;
    },

    setSelectedSubcategoriesIds(subcategory, selectedFathersIds = [], selectedIds = { total: [], toRemove: [] }) {
      if (subcategory.isSelected) {
        if (subcategory.childCategories) {
          subcategory.childCategories.forEach(childSubcategory => {
            const selectedFathersIdsAux = selectedFathersIds
              ? Object.entries(subcategory.idsByFatherCategory).reduce((accumulator, [k, v]) => {
                  if (selectedFathersIds.includes(Number(k))) {
                    v.forEach(subcategoryId => {
                      if (typeof subcategoryId === 'string' && subcategoryId.endsWith('_r')) {
                        accumulator.push(Number(subcategoryId.split('_')[0]));
                      } else {
                        accumulator.push(subcategoryId);
                      }
                    });
                  }
                  return accumulator;
                }, [])
              : [subcategory.id];
            this.setSelectedSubcategoriesIds(childSubcategory, selectedFathersIdsAux, selectedIds);
          });
        } else {
          if (selectedFathersIds) {
            Object.entries(subcategory.idsByFatherCategory).forEach(([k, v]) => {
              if (selectedFathersIds.includes(Number(k))) {
                v.forEach(subcategoryId => {
                  selectedIds.total.push(subcategoryId);
                });
              }
            });
          } else if (subcategory.level === 1) {
            // eslint-disable-next-line no-unused-vars
            Object.entries(subcategory.idsByFatherCategory).forEach(([k, v]) => {
              v.forEach(subcategoryId => {
                selectedIds.total.push(subcategoryId);
              });
            });
          } else {
            selectedIds.total.push(subcategory.id);
          }
        }
      } else {
        if (!subcategory.childCategories) {
          subcategory.ids.forEach(id => {
            selectedIds.toRemove.push(id);
          });
        }
      }
    },
    getPlayTime(gamePlay, timeProp) {
      let syncTime = '';
      let minutesToSubtract = 0;
      switch (gamePlay.matchLapse) {
        case 1:
          syncTime = gamePlay.syncStartFirstTime;
          break;
        case 2:
          syncTime = gamePlay.syncStartSecondTime;
          minutesToSubtract = 45;
          break;
        case 3:
          syncTime = gamePlay.syncStartFirstExtraTime;
          minutesToSubtract = 90;
          break;
        case 4:
          syncTime = gamePlay.syncStartSecondExtraTime;
          minutesToSubtract = 105;
          break;
        case 5:
          syncTime = gamePlay.syncStartPenals;
          minutesToSubtract = 120;
          break;
      }
      if (!syncTime || syncTime === '0') {
        syncTime = '00:00';
      }
      return this.getTimeToSeconds(syncTime) + (this.getTimeToSeconds(gamePlay[timeProp]) - minutesToSubtract * 60);
    },
    getTimeToSeconds(timeString) {
      const dotIndex = timeString.indexOf('.');
      const stringAux = dotIndex > -1 ? timeString.substring(0, timeString.indexOf('.')) : timeString;
      const [seconds, minutes, hours] = stringAux.split(':').reverse();

      return (hours ? Number(hours) * 60 * 60 : 0) + Number(minutes) * 60 + Number(seconds);
    },
    getFormattedPlays(arrayPlays, isMyPlaylists = false) {
      this.roundsAndGamesWithPlaysMap = new Map();
      playsPerGame = new Map();
      arrayPlays.forEach(play => {
        const playObject = play.reduce((accumulator, value, index) => {
          accumulator[playContentIndex[index]] = value;
          return accumulator;
        }, {});
        playObject.playRaw = play;
        playObject.stringMainCategoryName = this.objectCategorySelected.name;
        let gameAux = null;
        let player = null;
        let teamsMap = null;
        let maxGameId = 0;
        if (isMyPlaylists) {
          teamsMap = this.teamsMapMyPlaylists;
          maxGameId = this.maxGameIdMyPlaylists;
          gameAux = this.gamesMapMyPlaylists.get(playObject.gameId);
          player = this.playersMapMyPlaylists.get(playObject.playerId);
        } else {
          teamsMap = this.objectSeasonSelected.mapTeams;
          maxGameId = this.objectSeasonSelected.maxGameId;
          gameAux = this.objectSeasonSelected.mapGames.get(playObject.gameId);
          player = this.objectSeasonSelected.mapPlayers.get(playObject.playerId);
        }
        if (player && gameAux && playObject.gameId <= maxGameId) {
          /*const roundKey = `${gameAux.roundName},${gameAux.roundAbbreviation},${gameAux.seasonId}`;
          const roundAux = this.roundsAndGamesWithPlaysMap.get(roundKey);
          if (roundAux) {
            roundAux.set(gameAux.id, gameAux);
          } else {
            this.roundsAndGamesWithPlaysMap.set(roundKey, new Map().set(gameAux.id, gameAux));
          }*/
          playObject.game = gameAux;
          if (playObject.game.awayTeam.id === playObject.teamId) {
            playObject.teamName = playObject.game.awayTeam.name;
            playObject.rivalName = playObject.game.homeTeam.name;
          } else {
            playObject.teamName = playObject.game.homeTeam.name;
            playObject.rivalName = playObject.game.awayTeam.name;
          }
          playObject.playingAs = playObject.teamId === playObject.game.homeTeam.id ? 1 : 2;
          playObject.player = player;
          playObject.playerTeamLogo = teamsMap.get(playObject.player.teamId).logo;

          playObject.rivalTeamLogo = teamsMap.get(
            playObject.player.teamId === playObject.game.homeTeam.id
              ? playObject.game.awayTeam.id
              : playObject.game.homeTeam.id,
          ).logo;
          playObject.startSeconds = this.getPlayTime(playObject, 'startTime');
          playObject.endSeconds = this.getPlayTime(playObject, 'endTime');
          const gameDateTime = new Date(playObject.gameDate);
          const [hours, minutes] = playObject.gameHour.split(':');
          gameDateTime.setHours(hours);
          gameDateTime.setMinutes(minutes);
          playObject.dateTimeMillis = gameDateTime.valueOf();
          if (!playsPerGame.has(playObject.gameId)) {
            playsPerGame.set(playObject.gameId, { dateTimeMillis: gameDateTime.valueOf(), plays: [playObject] });
          } else {
            const playsInGame = playsPerGame.get(playObject.gameId);
            playsInGame.plays.push(playObject);
          }
        }
      });
      const playsPerGameArray = Array.from(playsPerGame.values());
      playsPerGameArray.sort((a, b) => {
        return b.dateTimeMillis - a.dateTimeMillis;
      });
      return playsPerGameArray.reduce((accumulator, playsInGame) => {
        playsInGame.plays.sort((a, b) => {
          return (
            Number(`${a.matchLapse}${a.startTime.replace(/:*\.*/g, '')}`) -
            Number(`${b.matchLapse}${b.startTime.replace(/:*\.*/g, '')}`)
          );
        });
        accumulator.push(...playsInGame.plays);
        return accumulator;
      }, []);
    },
    async fillAdvancedFilterCategories() {
      try {
        let mainCategories = [];
        if (this.advancedFilterCategories.isEmpty) {
          mainCategories = await this.fetchCategories();
          this.advancedFilterCategoriesRaw = {
            ...mainCategories,
          };
        } else {
          mainCategories = this.advancedFilterCategoriesRaw;
        }
        const mainCategoriesAux = [];
        if (mainCategories && mainCategories.length) {
          this.advancedFilterCategories = mainCategories.reduce(
            (accumulator, mainCategory) => {
              if (mainCategory.group_id !== 'g-55') {
                const mainCategoryAux = {
                  idAux: mainCategory.group_id,
                  ids: [
                    ...(mainCategory.ids ? mainCategory.ids : []),
                    ...(mainCategory.rival_Ids ? mainCategory.rival_Ids : []),
                  ],
                  type: mainCategory.type,
                  name: mainCategory.name,
                  coordinatePoint: mainCategory.coordinate_point,
                  requiresRivalTransform: rivalTransformCategories.includes(mainCategory.group_id),
                };
                mainCategoryAux.idsAux = [...mainCategoryAux.ids];
                (mainCategoryAux.subcategoryGroups =
                  mainCategory.group_id === 'g-12'
                    ? []
                    : this.getSubcategoryGroups(mainCategory, 0, new Map(), false, {}, mainCategoryAux.idsAux)),
                  mainCategoriesAux.push(mainCategoryAux);
                if (mainCategoryAux.type.includes(categoriesTypes.player)) {
                  accumulator.player.push(mainCategoryAux);
                }
                if (mainCategoryAux.type.includes(categoriesTypes.team)) {
                  if (mainCategoryAux.idAux !== 'g-2') {
                    accumulator.games.push(mainCategoryAux);
                  }
                  accumulator.team.push(mainCategoryAux);
                }
                if (mainCategoryAux.type.includes(categoriesTypes.goalkeeper)) {
                  accumulator.goalkeeper.push(mainCategoryAux);
                }
              }
              return accumulator;
            },
            {
              games: [],
              player: [],
              team: [],
              goalkeeper: [],
              isEmpty: false,
            },
          );
          const mapMinutesPlayedNames = new Map();
          const stringName = 'Resumen';
          const stringNameMinutesPlayed = 'Todas sus jugadas';
          const minutesPlayedRegularPlayer = this.advancedFilterCategories.player.reduce(
            (accumulator, objectCategory) => {
              const arraySubcategoryIds = this.getSubcategories(objectCategory);
              arraySubcategoryIds.forEach(numberId => {
                mapMinutesPlayedNames.set(numberId, objectCategory.name);
              });
              accumulator.push(...arraySubcategoryIds);
              return accumulator;
            },
            [],
          );
          const minutesPlayedGoalkeeper = this.advancedFilterCategories.goalkeeper.reduce(
            (accumulator, objectCategory) => {
              const arraySubcategoryIds = this.getSubcategories(objectCategory);
              arraySubcategoryIds.forEach(numberId => {
                mapMinutesPlayedNames.set(numberId, objectCategory.name);
              });
              accumulator.push(...arraySubcategoryIds);
              return accumulator;
            },
            [],
          );
          this.$store.commit('mediaGeneral/setMapMinutesPlayedCategoryNames', mapMinutesPlayedNames);
          this.advancedFilterCategories.games.unshift({
            name: stringName,
            arrayCategoriesIds: objectBestPlaysCategoryIds.games,
            booleanIsBestPlays: true,
          });
          this.advancedFilterCategories.team.unshift({
            name: stringName,
            arrayCategoriesIds: objectBestPlaysCategoryIds.team,
            booleanIsBestPlays: true,
          });
          this.advancedFilterCategories.player.unshift(
            {
              name: stringName,
              arrayCategoriesIds: objectBestPlaysCategoryIds.player.regular,
              booleanIsBestPlays: true,
            },
            {
              name: stringNameMinutesPlayed,
              arrayCategoriesIds: minutesPlayedRegularPlayer,
              booleanIsMinutesPlayed: true,
            },
          );
          this.advancedFilterCategories.goalkeeper.unshift(
            {
              name: stringName,
              arrayCategoriesIds: objectBestPlaysCategoryIds.player.goalkeeper,
              booleanIsBestPlays: true,
            },
            {
              name: stringNameMinutesPlayed,
              arrayCategoriesIds: minutesPlayedGoalkeeper,
              booleanIsMinutesPlayed: true,
            },
          );
        }
      } catch (e) {
        throw new Error(e);
      }
    },
    getSubcategoryGroups(
      category,
      groupLevel = 0,
      subcategoriesGroupsByLevel = new Map(),
      isRival = false,
      fatherCategory = {},
      mainCategoryIds = [],
    ) {
      if (!category.group_id) {
        return;
      }
      let subcategoriesByLevel = subcategoriesGroupsByLevel.get(groupLevel);
      const categoryId = isRival ? `${category.id_category}_r` : category.id_category;
      if (category.id_category) {
        mainCategoryIds.push(category.id_category);
      }
      let subcategoryAux = {
        ids: [categoryId],
        groupId: category.group_id,
        level: groupLevel,
        name: category.name,
        isSelected: true,
        fatherCategories: groupLevel > 0 ? [fatherCategory] : [],
        idsByFatherCategory: {
          [category.category_father]: [categoryId],
        },
      };
      if (groupLevel > 0) {
        if (groupLevel === 1) {
          subcategoryAux.id = category.id_category;
        }
      }
      if (subcategoriesByLevel && groupLevel !== 0) {
        const charAux = category.group_id.charAt(category.group_id.length - 1);
        const sameTopicSubcategory = subcategoriesByLevel.find(subcategory => subcategory.groupId.endsWith(charAux));
        if (sameTopicSubcategory && !subcategoriesExceptions.includes(subcategoryAux.groupId)) {
          subcategoryAux = sameTopicSubcategory;
          sameTopicSubcategory.ids.push(categoryId);
          sameTopicSubcategory.fatherCategories.push(fatherCategory);
          sameTopicSubcategory.fatherCategories.forEach(fatherCate => {
            if (fatherCate.childCategories) {
              const childAdded = fatherCate.childCategories.find(
                childCategory => childCategory.groupId === subcategoryAux.groupId,
              );
              if (!childAdded) {
                fatherCate.childCategories.push(subcategoryAux);
              }
            } else {
              fatherCate.childCategories = [subcategoryAux];
            }
          });
          if (sameTopicSubcategory.idsByFatherCategory[category.category_father]) {
            sameTopicSubcategory.idsByFatherCategory[category.category_father].push(categoryId);
          } else {
            sameTopicSubcategory.idsByFatherCategory[category.category_father] = [categoryId];
          }
        } else {
          subcategoryAux.fatherCategories.forEach(fatherCate => {
            if (fatherCate.childCategories) {
              const childAdded = fatherCate.childCategories.find(
                childCategory => childCategory.groupId === subcategoryAux.groupId,
              );
              if (!childAdded) {
                fatherCate.childCategories.push(subcategoryAux);
              }
            } else {
              fatherCate.childCategories = [subcategoryAux];
            }
          });
          subcategoriesByLevel.push(subcategoryAux);
        }
      } else if (groupLevel !== 0) {
        if (fatherCategory.childCategories) {
          fatherCategory.childCategories.push(subcategoryAux);
        } else {
          fatherCategory.childCategories = [subcategoryAux];
        }
        subcategoriesByLevel = [subcategoryAux];
        subcategoriesGroupsByLevel.set(groupLevel, subcategoriesByLevel);
      }
      if (category.categories && category.categories.length) {
        category.categories.forEach(subcategory => {
          this.getSubcategoryGroups(
            subcategory,
            groupLevel + 1,
            subcategoriesGroupsByLevel,
            isRival,
            subcategoryAux,
            mainCategoryIds,
          );
        });
      } else if (category.rival_categories && category.rival_categories.length) {
        category.rival_categories.forEach(subcategory => {
          this.getSubcategoryGroups(
            subcategory,
            groupLevel + 1,
            subcategoriesGroupsByLevel,
            true,
            subcategoryAux,
            mainCategoryIds,
          );
        });
      }
      if (groupLevel === 0) {
        return Array.from(subcategoriesGroupsByLevel.values());
      }
    },
    async fillSeasonPlayers(objectSeason) {
      try {
        const arrayPlayers = await this.getPlayersBySeasons({ seasonId: objectSeason.id, returnData: true });
        this.objectSeasonSelected.mapPlayers = new Map();
        this.objectSeasonSelected.mapPlayersByTeam = arrayPlayers.reduce((accumulator, objectPlayer) => {
          this.objectSeasonSelected.mapPlayers.set(objectPlayer.player_id, {
            id: objectPlayer.player_id,
            name: objectPlayer.player_name,
            shortName: objectPlayer.shortName,
            photo: objectPlayer.player_photo,
            teamId: objectPlayer.team_id,
            positionId: objectPlayer.position_id,
          });
          const arrayPlayersByTeam = accumulator.get(objectPlayer.team_id);
          if (arrayPlayersByTeam) {
            arrayPlayersByTeam.push(objectPlayer);
          } else {
            accumulator.set(objectPlayer.team_id, [objectPlayer]);
          }
          return accumulator;
        }, new Map());
      } catch (e) {
        throw new Error(e);
      }
    },
    async fillMatchDaysAndGames(objectSeason) {
      try {
        const {
          seasonsAndGames: arraySeasonsAndGames,
          seasonsAndTeams: arraySeasonsAndTeams,
        } = await this.fetchSeasonsGamesAndTeams(
          [objectSeason.id, ...objectSeason.related_seasons.map(objectRelatedSeason => objectRelatedSeason.id)],
          3,
        );
        const objectMainSeasonAndTeams = arraySeasonsAndTeams.find(
          objectSeasonAndTeams => objectSeasonAndTeams._id === objectSeason.id,
        );
        this.objectSeasonSelected.arrayTeams = [];
        this.objectSeasonSelected.mapTeams = new Map();
        const mapMainSeasonTeams = objectMainSeasonAndTeams.teams.reduce((accumulator, objectTeam) => {
          this.objectSeasonSelected.arrayTeams.push(objectTeam);
          this.objectSeasonSelected.mapTeams.set(objectTeam.team_id, {
            name: objectTeam.colloquial_name,
            acronym: objectTeam.acronym,
            logo: objectTeam.logo,
            id: objectTeam.team_id,
          });
          accumulator.set(objectTeam.team_id, objectTeam);
          return accumulator;
        }, new Map());
        this.objectTeamSelected = this.objectSeasonSelected.arrayTeams[0];
        this.objectSeasonSelected.mapGames = new Map();
        this.objectSeasonSelected.mapGamesByTeam = new Map();
        const arrayGamesByMatchDay = Array.from(
          arraySeasonsAndGames
            .reduce((accumulator, objectSeasonAndGames) => {
              objectSeasonAndGames.games.forEach(objectGame => {
                if (objectGame.game_status === 1 && objectGame.has_video) {
                  if (
                    !this.objectSeasonSelected.maxGameId ||
                    objectGame.game_id > this.objectSeasonSelected.maxGameId
                  ) {
                    this.objectSeasonSelected.maxGameId = objectGame.game_id;
                  }
                  let abbreviation = objectGame.matchday_abbreviation.replace('M', 'J');
                  let name = objectGame.matchday_abbreviation.replace('M', 'Jornada ');
                  const roundNumberString = objectGame.matchday_abbreviation.replace('M', '');
                  if (objectSeasonAndGames.season_type === 0) {
                    if (this.objectTournamentSelected.tournament_type === 1) {
                      if (objectGame.seasonId === 881) {
                        abbreviation = cupLegacyAbb[roundNumberString] || abbreviation;
                        name = cupLegacy[roundNumberString] || name;
                      } else {
                        abbreviation = cup[objectGame.matchday_abbreviation]
                          ? objectGame.matchday_abbreviation
                          : abbreviation;
                        name = cup[objectGame.matchday_abbreviation] || name;
                        if (abbreviation === 'FINAL') {
                          abbreviation = 'F';
                        }
                      }
                    }
                  } else if (objectSeasonAndGames.season_type === 1) {
                    abbreviation = regularLeague[objectGame.matchday_abbreviation];
                    name = abbreviation;
                  } else {
                    if (objectGame.matchday_id === 182) {
                      abbreviation = 'PI1';
                      name = 'Play In 1';
                    } else if (objectGame.matchday_id === 183) {
                      abbreviation = 'PI2';
                      name = 'Play In 2';
                    } else {
                      abbreviation = objectGame.matchday_abbreviation.replace('PO', 'R');
                      name = 'Repechaje';
                    }
                  }
                  objectGame.roundAbbreviation = abbreviation;
                  objectGame.roundName = name;
                  this.objectSeasonSelected.mapGames.set(objectGame.game_id, {
                    id: objectGame.game_id,
                    date: objectGame.date,
                    dateTimeMillis: new Date(objectGame.date_time_utc).valueOf(),
                    homeTeam: this.objectSeasonSelected.mapTeams.get(objectGame.home_team),
                    awayTeam: this.objectSeasonSelected.mapTeams.get(objectGame.visiting_team),
                    roundAbbreviation: objectGame.roundAbbreviation,
                    roundName: objectGame.roundName,
                    score: objectGame.score,
                    // 1 = local wins, 2 = away wins, 3 = tied
                    gameResult:
                      objectGame.score[0] > objectGame.score[1] ? 1 : objectGame.score[0] < objectGame.score[1] ? 2 : 3,
                    seasonId: objectSeasonAndGames.season_id,
                  });
                  const objectMatchDay = accumulator.get(objectGame.roundAbbreviation);
                  objectGame.numberDateTimeMillis = new Date(objectGame.date_time_utc).getTime();
                  objectGame.homeTeam = mapMainSeasonTeams.get(objectGame.home_team);
                  objectGame.awayTeam = mapMainSeasonTeams.get(objectGame.visiting_team);
                  const arrayGamesByHomeTeam = this.objectSeasonSelected.mapGamesByTeam.get(objectGame.home_team);
                  const arrayGamesByAwayTeam = this.objectSeasonSelected.mapGamesByTeam.get(objectGame.visiting_team);
                  if (arrayGamesByHomeTeam) {
                    arrayGamesByHomeTeam.push(objectGame);
                  } else {
                    this.objectSeasonSelected.mapGamesByTeam.set(objectGame.home_team, [objectGame]);
                  }
                  if (arrayGamesByAwayTeam) {
                    arrayGamesByAwayTeam.push(objectGame);
                  } else {
                    this.objectSeasonSelected.mapGamesByTeam.set(objectGame.visiting_team, [objectGame]);
                  }
                  if (objectMatchDay) {
                    objectMatchDay.arrayGames.push(objectGame);
                  } else {
                    accumulator.set(objectGame.roundAbbreviation, {
                      stringMatchDayAbbreviation: objectGame.roundAbbreviation,
                      stringMatchDayName: objectGame.roundName,
                      arrayGames: [objectGame],
                    });
                  }
                }
              });
              return accumulator;
            }, new Map())
            .values(),
        );
        arrayGamesByMatchDay.reverse();
        arrayGamesByMatchDay.forEach(objectMatchDay => {
          objectMatchDay.arrayGames.sort((a, b) => a.numberDateTimeMillis - b.numberDateTimeMillis);
        });
        this.objectSeasonSelected.arrayMatchDays = arrayGamesByMatchDay;
        this.objectMatchDaySelected = arrayGamesByMatchDay[0] || {};
      } catch (e) {
        throw new Error(e);
      }
    },
    /**
     * @author Alejandro Martinez
     * @param {Array<number>} seasons - seasons ids
     * @param {number} retries - Times to retry the request
     * @param {String} createdUrl - Url to make the request
     * @return {Promise<{seasonsAndGames: *, seasonsAndTeams: *}|*|undefined>}
     */
    async fetchSeasonsGamesAndTeams(seasons, retries, createdUrl = '') {
      this.$emit('set-is-loading', true);
      let gamesUrl = createdUrl;
      try {
        if (!gamesUrl) {
          gamesUrl = this.gamesUrl;
          seasons.forEach((seasonId, index) => {
            const prefix = index === 0 ? '' : '&';
            gamesUrl += `${prefix}seasons=${seasonId}`;
          });
        }
        const {
          data: { data, teams },
        } = await axios.get(gamesUrl);
        return { seasonsAndGames: data, seasonsAndTeams: teams };
      } catch (e) {
        if (retries > 0) {
          return this.fetchSeasonsGamesAndTeams(seasons, retries - 1, gamesUrl);
        }
        throw new Error(e);
      } finally {
        this.$emit('set-is-loading', false);
      }
    },
    getTournamentLogoUrl(numberTournamentId) {
      if (numberTournamentId === 33) {
        return 'https://golstatsimages.blob.core.windows.net/todoelfut/' + this.objectSeasonSelected.id + '.png';
      } else {
        return 'https://golstatsimages.blob.core.windows.net/todoelfut/' + numberTournamentId + '.png';
      }
    },
    onMatchDaySelected(objectMatchDay) {
      this.objectMatchDaySelected = objectMatchDay;
    },
    onSeasonSelected(objectSeason) {
      this.objectSeasonSelected = objectSeason;
    },
    onTournamentSelected(objectTournament) {
      this.objectTournamentSelected = objectTournament;
      this.objectSeasonSelected = this.objectTournamentSelected.arraySeasons[0];
    },
    onTeamSelected(objectTeam) {
      this.objectTeamSelected = objectTeam;
    },
    onPlayerSelected(objectPlayer) {
      this.objectPlayerSelected = objectPlayer;
    },
    onGameSelected(objectGame) {
      this.objectGameSelected = objectGame;
    },
    onCategorySelected(objectCategory) {
      this.objectCategorySelected = objectCategory;
    },
    onClickShowAdvanced() {
      this.booleanAreAdvancedVisible = !this.booleanAreAdvancedVisible;
    },
    onClickApplyFilters() {
      if (this.actionId === 1) {
        this.applyGoalsFilters();
      } else if (this.actionId === 5) {
        this.$emit('click-full-game', {
          arrayMatchDayGames: this.objectMatchDaySelected.arrayGames,
          objectGame: this.objectGameSelected,
          objectTournamentSelected: this.objectTournamentSelected,
          objectSeasonSelected: this.objectSeasonSelected,
        });
      } else {
        this.applySummaryFilters();
      }
    },
    onClickCancel() {
      this.$emit('cancel');
      this.booleanArePlaysEmpty = false;
    },
  },
  created() {
    this.fillAdvancedFilterCategories();
  },
};
</script>

<style scoped lang="scss">
.filters {
  font-size: 1rem;
  width: 100%;
  padding: 0 2em;

  &__advanced {
    width: 100%;
  }

  &__general {
    width: 100%;
    padding: 0.625em;
    border-radius: 9px;
    border: solid 1px #dbe2ed;
    display: grid;
    grid-template-columns: 4.375em 1fr 1fr;
    column-gap: 10px;
    row-gap: 10px;
    grid-template-areas:
      'tournaments seasons match-days'
      'teams teams teams'
      'players players players'
      'games games games'
      'categories categories categories';

    &.goals-layout {
      & .teams {
        display: none;
      }

      & .players {
        display: none;
      }

      & .categories {
        display: none;
      }

      & ~ div.filters__show-advanced {
        display: none;
      }

      & ~ div.filters__advanced {
        display: none;
      }

      grid-template-columns: repeat(3, 1fr);
      grid-template-areas:
        'tournaments seasons match-days'
        'games games games';

      @media screen and (max-width: 440px) {
        grid-template-columns: repeat(4, 1fr);
        grid-template-areas:
          'tournaments tournaments seasons seasons'
          'match-days games games games';
      }
    }

    &.summary-game-layout {
      & .teams {
        display: none;
      }

      & .players {
        display: none;
      }

      grid-template-columns: repeat(3, 1fr);
      grid-template-areas:
        'tournaments seasons match-days'
        'games games games'
        'categories categories categories';

      @media screen and (max-width: 440px) {
        grid-template-columns: repeat(4, 1fr);
        grid-template-areas:
          'tournaments tournaments seasons seasons'
          'match-days games games games'
          'categories categories categories categories';
      }
    }

    &.summary-teams-layout {
      & .match-days {
        display: none;
      }

      & .players {
        display: none;
      }

      grid-template-columns: repeat(3, 1fr);
      grid-template-areas:
        'tournaments seasons teams'
        'games games games'
        'categories categories categories';

      @media screen and (max-width: 440px) {
        grid-template-columns: repeat(6, 1fr);
        grid-template-areas:
          'tournaments tournaments tournaments seasons seasons seasons'
          'teams teams games games games games'
          'categories categories categories categories categories categories';
      }
    }

    &.summary-players-layout {
      & .match-days {
        display: none;
      }

      grid-template-columns: repeat(3, 1fr);
      grid-template-areas:
        'tournaments seasons teams'
        'players players players'
        'games games games'
        'categories categories categories';

      @media screen and (max-width: 440px) {
        grid-template-columns: repeat(6, 1fr);
        grid-template-areas:
          'tournaments tournaments tournaments seasons seasons seasons'
          'teams teams players players players players'
          'games games games games games games'
          'categories categories categories categories categories categories';
      }
    }
  }

  &__season-add {
    width: 100%;
    border-radius: 26px;
    background-color: #32353d;
    font-family: Roboto-Regular, sans-serif;
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 0.97;
    letter-spacing: -0.12px;
    text-align: center;
    color: #fff;
    padding: 1em 0.5em;
    margin-top: 1.5em;
  }

  &__show-advanced {
    margin: 1.625em 0;
    font-family: Roboto-Regular, sans-serif;
    font-size: 0.875em;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 0.83;
    letter-spacing: -0.14px;
    text-align: center;
    color: #677682;
    text-decoration: underline;
    cursor: pointer;
  }

  &__button-apply {
    margin: 1em auto 0;
    width: 100%;
    max-width: 270px;
    padding: 0.8em 0;
    border-radius: 25px;
    background-color: #4a88ff;
    color: white;
    font-family: Roboto-Regular, sans-serif;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 0.72;
    letter-spacing: -0.16px;
    cursor: pointer;
  }

  &__empty {
    display: flex;
    flex-direction: column;
    align-items: center;

    &__warning {
      height: 56px;
      width: 56px;
      margin: 1em 0;

      & > img {
        height: 56px;
        width: 56px;
      }
    }

    &__message {
      font-family: Avenir-Demi, sans-serif;
      font-size: 21px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.19;
      letter-spacing: -0.42px;
      text-align: center;
      color: #132839;
    }

    &__buttons {
      width: 100%;
      display: flex;
      justify-content: center;
      margin-top: 2.5em;

      &__button {
        width: 100%;
        max-width: 165px;
        border-radius: 25px;
        cursor: pointer;
        margin: 0 0.5em;
        font-family: Roboto-Regular, sans-serif;
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 0.72;
        letter-spacing: -0.16px;
        text-align: center;
        color: #000;
        padding: 0.8em 0;

        &.cancel {
          border: solid 1px #000;
        }

        &.modify {
          color: white;
          background-color: #4a88ff;
        }
      }
    }
  }

  @media screen and (max-width: 490px) {
    padding: 0 0.5em;
  }
}

.tournaments {
  grid-area: tournaments;
}

.seasons {
  grid-area: seasons;
}

.match-days {
  grid-area: match-days;
}

.teams {
  grid-area: teams;
}

.players {
  grid-area: players;
}

.games {
  grid-area: games;
}

.categories {
  grid-area: categories;
}

.drop-down-container {
  width: 100%;
}

.drop-down-trigger {
  width: 100%;
  min-height: 2.34em;
  border-radius: 4px;
  border: solid 1px #ccd6dd;
  background-color: #fff;
  position: relative;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0 2.4em 0 0.6em;
  font-family: Roboto-Regular, sans-serif;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.97;
  letter-spacing: -0.12px;
  text-align: center;
  color: #1d220f;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  & > div {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  & > div.icn-arrow-down {
    position: absolute;
    right: 8px;
  }
}

.selected-tournament {
  display: flex;
  align-items: center;
  height: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  & > img {
    height: auto;
    width: 24px;
    margin-right: 0.2em;
  }
}

.item-tournament {
  display: flex;
  justify-content: flex-start;
  align-items: center;

  &__logo {
    height: auto;
    width: 20px;
    margin-right: 0.5em;

    & > img {
      height: auto;
      width: 20px;
    }
  }
}

.item-game {
  display: flex;
  justify-content: flex-start;
  align-items: center;

  & .match-day {
    margin-right: 0.4em;
  }

  & .score {
    margin: 0 0.5em;
  }

  & .text {
  }

  & .team-logo {
    height: 1.4em;
    width: 1.4em;
    margin: 0 0.2em;

    & > img {
      height: 1.4em;
      width: 1.4em;
    }
  }
}
.filters-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>

<style lang="scss">
.drop-down-container {
  & div.dropdown-content {
    position: fixed;
  }
}
</style>
